import React from 'react';
import cx from 'classnames';
import { FairPhonesData } from '../../../../types';
import Phone from '../Phone';
import styles from './index.module.scss';

const FairPhones = ({ data }: FairPhonesData) => {
  return (
    <div className="my-9 md:my-12 lg:my-16 xl:my-32">
      <div
        className={cx(
          styles.root,
          'px-9 md:px-12 lg:px-16 xl:px-32 pt-9 md:pt-12 lg:pt-16 xl:pt-32',
        )}
      >
        <div className={styles.grid}>
          <div className={styles.headline}>
            {/* TODO: replace */}
            <svg viewBox="0 0 471 270" version="1.1">
              <defs>
                <polygon
                  id="path-1"
                  points="0.431782796 22.9632455 56.5022989 22.9632455 56.5022989 85.6726069 0.431782796 85.6726069"
                ></polygon>
                <polygon
                  id="path-3"
                  points="-39 85.6726069 126.914323 85.6726069 126.914323 0 -39 0"
                ></polygon>
              </defs>
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-241.000000, -2713.000000)">
                  <g transform="translate(0.000000, 2419.000000)">
                    <g transform="translate(241.000000, 294.000000)">
                      <g transform="translate(39.000000, 0.000000)">
                        <path
                          d="M80.6939133,7.92457379 C80.6939133,12.3010841 77.1353254,15.849029 72.7449527,15.849029 C68.3545799,15.849029 64.7948022,12.3010841 64.7948022,7.92457379 C64.7948022,3.54806345 68.3545799,0.00011862069 72.7449527,0.00011862069 C77.1353254,0.00011862069 80.6939133,3.54806345 80.6939133,7.92457379"
                          fill="#FF5A00"
                        ></path>
                        <mask fill="white">
                          <use xlinkHref="#path-1"></use>
                        </mask>

                        <path
                          d="M37.6288724,54.91788 C36.6304925,55.53708 35.6231878,56.03588 34.6063634,56.4172455 C33.5895391,56.7997972 32.1949011,57.1544731 30.4206645,57.4800869 L26.8710014,58.1348731 C23.5450516,58.7173007 21.1556036,59.4266524 19.7050373,60.2623352 C17.2495462,61.6798524 16.0220982,63.8796731 16.0220982,66.8600179 C16.0220982,69.5135628 16.7717756,71.4328455 18.2723204,72.6125283 C19.7710803,73.7945834 21.5947004,74.3847214 23.7431806,74.3847214 C27.150048,74.3847214 30.2879835,73.4037283 33.1581771,71.4405559 C36.0277756,69.4773834 37.5176108,65.8968179 37.6288724,60.6982662 L37.6288724,54.91788 Z M28.0966645,47.6648179 C30.9977971,47.3024317 33.0730946,46.8481145 34.322557,46.3024593 C36.5638545,45.3564593 37.6842057,43.8849697 37.6842057,41.8844317 C37.6842057,39.4503352 36.8244566,37.7677007 35.1055534,36.84068 C33.3872452,35.9142524 30.8633312,35.4504455 27.5373814,35.4504455 C23.8038688,35.4504455 21.1597685,36.35908 19.6074602,38.1769421 C18.4984136,39.5221007 17.7588509,41.3399628 17.389962,43.6299352 L2.34643513,43.6299352 C2.67546022,38.4313834 4.14090108,34.1604455 6.74156774,30.8159352 C10.8802631,25.580611 17.9855391,22.9632455 28.0585857,22.9632455 C34.6146932,22.9632455 40.4377828,24.2538386 45.5296394,26.8350248 C50.6197111,29.4168041 53.1656394,34.2873697 53.1656394,41.4485007 L53.1656394,68.7140593 C53.1656394,70.6048731 53.2013384,72.8948455 53.2745211,75.5845697 C53.3845928,77.6206938 53.6939835,79.0020317 54.2050731,79.7291766 C54.7149728,80.4569145 55.4807147,81.0565421 56.5022989,81.5286524 L56.5022989,83.8192179 L39.5447147,83.8192179 C39.070514,82.6193697 38.7414889,81.4930662 38.5594244,80.4373421 C38.3767649,79.3839903 38.2315892,78.1841421 38.1227075,76.8389834 C35.9575677,79.1657283 33.4628079,81.1466938 30.6390229,82.78188 C27.2648796,84.7094662 23.4486645,85.6726662 19.1939477,85.6726662 C13.7653312,85.6726662 9.28035627,84.1371214 5.74140287,81.0648455 C2.2012595,77.9925697 0.431782796,73.6403766 0.431782796,68.0047076 C0.431782796,60.6982662 3.27877204,55.4083766 8.97334552,52.137411 C12.0964065,50.3563214 16.6884781,49.0829283 22.7507505,48.319011 L28.0966645,47.6648179 Z"
                          fill="#FF5A00"
                          mask="url(#mask-2)"
                        ></path>
                        <mask id="mask-4" fill="white">
                          <use xlinkHref="#path-3"></use>
                        </mask>
                        <g id="Clip-7"></g>
                        <polygon
                          fill="#FF5A00"
                          mask="url(#mask-4)"
                          points="64.8344875 83.8185655 80.6437563 83.8185655 80.6437563 24.3807034 64.8344875 24.3807034"
                        ></polygon>
                        <path
                          d="M125.574363,22.9905283 C125.774277,23.0089145 126.221704,23.0367903 126.914263,23.0723766 L126.914263,38.9942386 C125.930163,38.8857007 125.054349,38.8139352 124.288607,38.7765697 C123.522865,38.7415766 122.902299,38.7225972 122.428693,38.7225972 C116.155797,38.7225972 111.943919,40.7587214 109.793059,44.8291903 C108.588815,47.1197559 107.987288,50.646349 107.987288,55.4083766 L107.987288,83.8192179 L92.288091,83.8192179 L92.288091,24.3807628 L107.167403,24.3807628 L107.167403,34.7410938 C109.57351,30.7797559 111.670227,28.0710524 113.457553,26.6161697 C116.374751,24.18148 120.167166,22.9632455 124.835991,22.9632455 C125.127532,22.9632455 125.373259,22.9721421 125.574363,22.9905283"
                          fill="#FF5A00"
                          mask="url(#mask-4)"
                        ></path>
                        <path
                          d="M-3.36765376,0.0393227586 C-16.2383061,0.0393227586 -24.9577685,4.06590207 -29.5284208,12.1184676 C-31.9809369,16.512771 -33.20779,22.6537641 -33.20779,30.5402607 L-33.20779,30.8142745 L-38.9999405,30.8142745 L-38.9999405,43.8026469 L-33.20779,43.8026469 L-33.20779,83.8187434 L-17.404471,83.8187434 L-17.404471,43.8026469 L-4.46063584,43.8026469 L-4.46063584,30.8142745 L-17.404471,30.8142745 L-17.404471,30.57644 C-17.404471,25.4804952 -16.7993742,21.7581779 -15.5927505,19.4124538 C-13.7143921,15.2536124 -9.63995484,13.1753779 -3.36765376,13.1753779 C-2.78516631,13.1753779 -2.24135269,13.2121503 -1.69694409,13.2477366 L-1.69694409,0.107529655 C-2.26039211,0.0909227586 -2.78754624,0.0393227586 -3.36765376,0.0393227586"
                          fill="#FF5A00"
                          mask="url(#mask-4)"
                        ></path>
                      </g>
                      <text
                        fontFamily="Helvetica"
                        fontSize="75"
                        fontWeight="normal"
                        // lineSpacing="86"
                        letterSpacing="-1.41723353"
                        fill="#000000"
                      >
                        <tspan x="0" y="159">
                          Get a Car on{' '}
                        </tspan>
                        <tspan x="0" y="245">
                          Your Phone
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          {data.map(({ image }, i) => (
            <div className={styles.phone} key={i}>
              <Phone image={image} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FairPhones;
